import { Link } from 'react-router-dom'

import { Payment } from '../../../models/Payment'
import { currencyFormat } from '../../../utils/numbers'
import Card from '../../app/design/Card'
import Label from '../../app/design/Label'
import Paragraph from '../../app/design/Paragraph'
import { ContactAvatar } from '../../contacts/ContactAvatar'

type Props = {
    payments: Payment[]
}

export const PaymentsSection = ({ payments }: Props) => {
    if (payments.length === 0) {
        return null
    }

    return (
        <Card
            className="flex flex-col items-stretch justify-start gap-y-8"
            title="Payments"
            count={payments.length > 0 ? payments.length : undefined}
        >
            {payments.length > 0 && (
                <div className="flex flex-col items-stretch justify-start gap-y-8">
                    {payments.map((payment) => (
                        <Link
                            key={payment.id ?? ''}
                            to={`/payments/${payment.id}`}
                            className="group relative flex items-center justify-center gap-x-4"
                        >
                            <div className="absolute -inset-4 z-10 rounded-lg bg-black/4 opacity-0 group-hover:opacity-100" />

                            {payment.client && (
                                <ContactAvatar user={payment.client} className="z-20 shrink-0" />
                            )}
                            <div className="z-20 flex grow flex-col items-stretch justify-start gap-y-1">
                                <div className="flex items-center justify-between">
                                    <Label size="md" className="text-gray-700">
                                        {payment.client?.name}
                                    </Label>
                                    <Label size="md" className="text-gray-700">
                                        {currencyFormat(payment.amount)}
                                    </Label>
                                </div>
                                <Paragraph size="sm" className="text-gray-600">
                                    {payment.createdDate?.format('MMM Do, YYYY')}
                                </Paragraph>
                            </div>
                        </Link>
                    ))}
                </div>
            )}
        </Card>
    )
}
